import { render } from "./IconMultiColor.vue?vue&type=template&id=ed85d94c&scoped=true"
const script = {}

import "./IconMultiColor.vue?vue&type=style&index=0&id=ed85d94c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed85d94c"]])

export default __exports__